<template>
  <v-container v-if="currentTemplate">
    <v-row>
      <v-col stretch>
        <v-breadcrumb
          v-if="$route.name === 'createTemplateSnippet'"
          :items="breadcrumbCreateTemplateItems"
          :mobile="breadcrumbMobileCreateItem"
        ></v-breadcrumb>
        <v-breadcrumb
          v-if="$route.name === 'editTemplateSnippet'"
          :items="breadcrumbEditTemplateItems"
          :mobile="breadcrumbMobileEditItem"
        ></v-breadcrumb>
      </v-col>
    </v-row>
    <v-row>
      <v-col stretch>
        <v-title-bar v-if="$route.name === 'createTemplateSnippet'" :title="$t('titles.createTemplateSnippet')">
          <v-button
            class="wrap-btn"
            primary
            :active="teamCan('template-snippets')"
            :withLockIcon="!teamCan('template-snippets')"
            @click.native="submitTemplateSnippet(false)"
            >{{ $t("actions.next") }}</v-button
          >
        </v-title-bar>
        <v-title-bar v-if="$route.name === 'editTemplateSnippet'" :title="$t('titles.editTemplateSnippet')">
          <v-button
            class="wrap-btn"
            primary
            :active="teamCan('template-snippets')"
            :withLockIcon="!teamCan('template-snippets')"
            @click.native="submitTemplateSnippet(true)"
            >{{ $t("actions.save") }}</v-button
          >
        </v-title-bar>
      </v-col>
    </v-row>
    <form @submit.prevent>
      <v-row>
        <v-col class="col-12">
          <v2-select
            v-if="$route.name === 'createTemplateSnippet'"
            :placeholder="$t('templateSnippets.type')"
            v-model="type"
            :options="typeOptions"
            optionLabel="label"
            id="type"
            name="type"
            v-validate="'required'"
            :error="errors.first('type')"
            :data-vv-as="$t('templateSnippets.type')"
          ></v2-select>
          <v-textfield
            :placeholder="$t('templateSnippets.name')"
            v-model="name"
            :required="true"
            v-validate="'required'"
            name="name"
            :error="errors.first('name')"
            :data-vv-as="$t('templateSnippets.name')"
          />
        </v-col>

        <!-- START SUBJECT EDIT --->
        <v-col class="col-12" v-if="$route.name === 'editTemplateSnippet' && currentSnippetType === 'email'">
          <v-list-header simple>
            <v-list-header-cell
              :title="
                $t('titles.templateSnippetDefaultSubject', {
                  lang: $t('lang.' + currentTemplate.locale),
                })
              "
            />
          </v-list-header>
          <ul v-if="loadingLangSubject !== 'default'" class="list">
            <v-list-item simple flexibleHeight>
              <v-list-cell :title="$t('gender.default')" />
              <v-list-cell size="2" :truncate="false">
                <div slot="value" class="w-full">
                  <span class="placeholder" v-if="!defaultSubject.default && editingSubjectField !== 'default-default'">
                    {{ $t("placeholders.noDefaultSnippetValue") }}</span
                  >
                  <v-redactor
                    v-if="editingSubjectField === 'default-default'"
                    :placeholder="''"
                    v-model="defaultSubject.default"
                    :no-html="true"
                    :required="true"
                    v-validate="'required'"
                    :config="redactorCustomConfig"
                    name="defaultSubject"
                    :error="errors.first('defaultSubject')"
                    :data-vv-as="$t('templateSnippets.defaultSubject')"
                  />
                  <v-list-cell v-if="editingSubjectField !== 'default-default'" :value="defaultSubject.default" />
                </div>
              </v-list-cell>
              <v-list-cell
                v-show="
                  editingField === '' && (editingSubjectField === '' || editingSubjectField === 'default-default')
                "
                :button="editingSubjectField ? $t('actions.continue') : $t('actions.edit')"
                :onClick="
                  () => {
                    toggleEditor('default-default', 'subject');
                  }
                "
              />
            </v-list-item>
            <v-list-item
              simple
              flexibleHeight
              :key="'defaultSubjectGender-' + genderSubject.key"
              v-for="genderSubject in $h.getOrderedGenderArrayWithoutDefault(defaultSubject)"
            >
              <v-list-cell :title="$t('gender.' + genderSubject.key)" />
              <v-list-cell size="2" :truncate="false">
                <div slot="value" class="w-full">
                  <span
                    class="placeholder"
                    v-if="!defaultSubject[genderSubject.key] && editingSubjectField !== 'default-' + genderSubject.key"
                    >{{ $t("placeholders.noLanguageSnippetValue") }}</span
                  >
                  <v-redactor
                    v-if="editingSubjectField === 'default-' + genderSubject.key"
                    :placeholder="''"
                    :no-html="true"
                    v-model="defaultSubject[genderSubject.key]"
                    :config="redactorCustomConfig"
                  />
                  <v-list-cell
                    v-if="editingSubjectField !== 'default-' + genderSubject.key"
                    :value="defaultSubject[genderSubject.key]"
                  />
                </div>
              </v-list-cell>
              <v-list-cell
                v-show="
                  editingField === '' &&
                  (editingSubjectField === '' || editingSubjectField === 'default-' + genderSubject.key)
                "
                :button="editingSubjectField ? $t('actions.continue') : $t('actions.edit')"
                :onClick="
                  () => {
                    toggleEditor('default-' + genderSubject.key, 'subject');
                  }
                "
              />
            </v-list-item>
          </ul>
        </v-col>
        <v-col class="col-12" :key="'subject-' + locale" v-for="(subject, locale) in filteredLocaleSubject">
          <v-list-header simple>
            <v-list-header-cell
              :title="
                $t('titles.templateSnippetLanguageSubject', {
                  lang: $t('lang.' + locale),
                })
              "
            />
            <v-list-header-cell
              :simple-link="$t('actions.remove')"
              :onClick="
                () => {
                  removeLangSubject(locale);
                }
              "
            />
          </v-list-header>
          <ul v-if="loadingLangSubject !== locale" class="list">
            <v-list-item simple flexibleHeight>
              <v-list-cell :title="$t('gender.default')" />
              <v-list-cell size="2" :truncate="false">
                <div slot="value" class="w-full">
                  <span class="placeholder" v-if="!subject.default && editingSubjectField !== locale + '-default'">
                    {{ $t("placeholders.noDefaultSnippetValue") }}</span
                  >
                  <v-redactor
                    v-if="editingSubjectField === locale + '-default'"
                    :placeholder="''"
                    v-model="subject.default"
                    :config="redactorCustomConfig"
                    :no-html="true"
                    :required="true"
                    v-validate="'required'"
                    :name="'defaultSubject-' + (locale + '-default')"
                    :error="errors.first('defaultSubject-' + (locale + '-default'))"
                    :data-vv-as="$t('templateSnippets.defaultSubject')"
                  />
                  <v-list-cell v-if="editingSubjectField !== locale + '-default'" :value="subject.default" />
                </div>
              </v-list-cell>
              <v-list-cell
                v-show="
                  editingField === '' && (editingSubjectField === '' || editingSubjectField === locale + '-default')
                "
                :button="editingSubjectField ? $t('actions.continue') : $t('actions.edit')"
                :onClick="
                  () => {
                    toggleEditor(locale + '-default', 'subject');
                  }
                "
              />
            </v-list-item>
            <v-list-item
              simple
              flexibleHeight
              :key="'subjectGender-' + genderSubject.key"
              v-for="genderSubject in $h.getOrderedGenderArrayWithoutDefault(subject)"
            >
              <v-list-cell :title="$t('gender.' + genderSubject.key)" />
              <v-list-cell size="2" :truncate="false">
                <div slot="value" class="w-full">
                  <span
                    class="placeholder"
                    v-if="!subject[genderSubject.key] && editingSubjectField !== locale + '-' + genderSubject.key"
                  >
                    {{ $t("placeholders.noLanguageSnippetValue") }}</span
                  >
                  <v-redactor
                    v-if="editingSubjectField === locale + '-' + genderSubject.key"
                    :placeholder="''"
                    v-model="subject[genderSubject.key]"
                    :config="redactorCustomConfig"
                    :no-html="true"
                  />
                  <v-list-cell
                    v-if="editingSubjectField !== locale + '-' + genderSubject.key"
                    :value="subject[genderSubject.key]"
                  />
                </div>
              </v-list-cell>
              <v-list-cell
                v-show="
                  editingField === '' &&
                  (editingSubjectField === '' || editingSubjectField === locale + '-' + genderSubject.key)
                "
                :button="editingSubjectField ? $t('actions.continue') : $t('actions.edit')"
                :onClick="
                  () => {
                    toggleEditor(locale + '-' + genderSubject.key, 'subject');
                  }
                "
              />
            </v-list-item>
          </ul>
        </v-col>
        <v-col
          v-if="
            $route.name === 'editTemplateSnippet' &&
            localeSubjectRemainingOptions.length &&
            currentSnippetType === 'email'
          "
          class="col-8"
        >
          <v-row>
            <v-col class="col-4 px-0">
              <v2-select
                :placeholder="''"
                v-model="selectedSubjectLanguageToAdd"
                :options="localeSubjectRemainingOptions"
                optionLabel="label"
                id="add-lang"
                name="add-lang"
                :allow-empty="false"
              ></v2-select>
            </v-col>
            <v-col class="col-8">
              <v-button lavender @click.native="addLangSubject">{{
                $t("actions.addLanguageSubject", {
                  lang: $t("lang." + selectedSubjectLanguageToAdd.value),
                })
              }}</v-button>
            </v-col>
          </v-row>
        </v-col>
        <!-- END SUBJECT EDIT -->

        <!-- START CONTENT EDIT -->
        <v-col class="col-12" v-if="$route.name === 'editTemplateSnippet'">
          <v-list-header simple>
            <v-list-header-cell
              :title="
                $t('titles.templateSnippetDefaultContent', {
                  lang: $t('lang.' + currentTemplate.locale),
                })
              "
            />
          </v-list-header>
          <ul v-if="loadingLangContent !== 'default'" class="list">
            <v-list-item simple flexibleHeight>
              <v-list-cell :title="$t('gender.default')" />
              <v-list-cell size="2" :truncate="false">
                <div slot="value" class="w-full">
                  <span class="placeholder" v-if="!defaultValue.default && editingField !== 'default-default'">
                    {{ $t("placeholders.noDefaultSnippetValue") }}</span
                  >
                  <v-redactor
                    v-if="editingField === 'default-default'"
                    :no-html="currentSnippetType === 'email'"
                    :placeholder="''"
                    v-model="defaultValue.default"
                    :required="true"
                    v-validate="'required'"
                    :config="redactorCustomConfig"
                    name="defaultValue"
                    :error="errors.first('defaultValue')"
                    :data-vv-as="$t('templateSnippets.defaultValue')"
                  />
                  <v-list-cell v-if="editingField !== 'default-default'" :value="defaultValue.default" />
                </div>
              </v-list-cell>
              <v-list-cell
                v-show="editingSubjectField === '' && (editingField === '' || editingField === 'default-default')"
                :button="editingField ? $t('actions.next') : $t('actions.edit')"
                :onClick="
                  () => {
                    toggleEditor('default-default');
                  }
                "
              />
            </v-list-item>
            <v-list-item
              simple
              flexibleHeight
              :key="'defaultContentSubject-' + genderContent.key"
              v-for="genderContent in $h.getOrderedGenderArrayWithoutDefault(defaultValue)"
            >
              <v-list-cell :title="$t('gender.' + genderContent.key)" />
              <v-list-cell size="2" :truncate="false">
                <div slot="value" class="w-full">
                  <span
                    class="placeholder"
                    v-if="!defaultValue[genderContent.key] && editingField !== 'default-' + genderContent.key"
                    >{{ $t("placeholders.noLanguageSnippetValue") }}</span
                  >
                  <v-redactor
                    v-if="editingField === 'default-' + genderContent.key"
                    :placeholder="''"
                    :no-html="currentSnippetType === 'email'"
                    v-model="defaultValue[genderContent.key]"
                    :config="redactorCustomConfig"
                  />
                  <v-list-cell
                    v-if="editingField !== 'default-' + genderContent.key"
                    :value="defaultValue[genderContent.key]"
                  />
                </div>
              </v-list-cell>
              <v-list-cell
                v-show="
                  editingSubjectField === '' && (editingField === '' || editingField === 'default-' + genderContent.key)
                "
                :button="editingField ? $t('actions.next') : $t('actions.edit')"
                :onClick="
                  () => {
                    toggleEditor('default-' + genderContent.key);
                  }
                "
              />
            </v-list-item>
          </ul>
        </v-col>
        <v-col class="col-12" :key="'content-' + locale" v-for="(content, locale) in filteredLocaleContent">
          <v-list-header simple>
            <v-list-header-cell
              :title="
                $t('titles.templateSnippetLanguageContent', {
                  lang: $t('lang.' + locale),
                })
              "
            />
            <v-list-header-cell
              :simple-link="$t('actions.remove')"
              :onClick="
                () => {
                  removeLangContent(locale);
                }
              "
            />
          </v-list-header>
          <ul v-if="loadingLangContent !== locale" class="list">
            <v-list-item simple flexibleHeight>
              <v-list-cell :title="$t('gender.default')" />
              <v-list-cell size="2" :truncate="false">
                <div slot="value" class="w-full">
                  <span class="placeholder" v-if="!content.default && editingField !== locale + '-default'">
                    {{ $t("placeholders.noDefaultSnippetValue") }}</span
                  >
                  <v-redactor
                    v-if="editingField === locale + '-default'"
                    :placeholder="''"
                    v-model="content.default"
                    :no-html="currentSnippetType === 'email'"
                    :required="true"
                    v-validate="'required'"
                    :config="redactorCustomConfig"
                    :name="'defaultValue-' + (locale + '-default')"
                    :data-vv-as="$t('templateSnippets.defaultValue')"
                  />
                  <v-list-cell v-if="editingField !== locale + '-default'" :value="content.default" />
                </div>
              </v-list-cell>
              <v-list-cell
                v-show="editingSubjectField === '' && (editingField === '' || editingField === locale + '-default')"
                :button="editingField ? $t('actions.next') : $t('actions.edit')"
                :onClick="
                  () => {
                    toggleEditor(locale + '-default');
                  }
                "
              />
            </v-list-item>
            <v-list-item
              simple
              flexibleHeight
              :key="'contentSubject' + genderContent.key"
              v-for="genderContent in $h.getOrderedGenderArrayWithoutDefault(content)"
            >
              <v-list-cell :title="$t('gender.' + genderContent.key)" />
              <v-list-cell size="2" :truncate="false">
                <div slot="value" class="w-full">
                  <span
                    class="placeholder"
                    v-if="!content[genderContent.key] && editingField !== locale + '-' + genderContent.key"
                  >
                    {{ $t("placeholders.noLanguageSnippetValue") }}</span
                  >
                  <v-redactor
                    v-if="editingField === locale + '-' + genderContent.key"
                    :placeholder="''"
                    v-model="content[genderContent.key]"
                    :config="redactorCustomConfig"
                    :name="locale + '-' + genderContent.key"
                    :no-html="currentSnippetType === 'email'"
                  />
                  <v-list-cell
                    v-if="editingField !== locale + '-' + genderContent.key"
                    :value="content[genderContent.key]"
                  />
                </div>
              </v-list-cell>
              <v-list-cell
                v-show="
                  editingSubjectField === '' &&
                  (editingField === '' || editingField === locale + '-' + genderContent.key)
                "
                :button="editingField ? $t('actions.next') : $t('actions.edit')"
                :onClick="
                  () => {
                    toggleEditor(locale + '-' + genderContent.key);
                  }
                "
              />
            </v-list-item>
          </ul>
        </v-col>
        <v-col class="col-8">
          <v-row v-if="$route.name === 'editTemplateSnippet' && localeRemainingOptions.length">
            <v-col class="col-4 px-0">
              <v2-select
                :placeholder="''"
                v-model="selectedLanguageToAdd"
                :options="localeRemainingOptions"
                optionLabel="label"
                id="add-lang"
                name="add-lang"
                :allow-empty="false"
              ></v2-select>
            </v-col>
            <v-col class="col-8">
              <v-button lavender @click.native="addLangContent">{{
                $t("actions.addLanguageContent", {
                  lang: $t("lang." + selectedLanguageToAdd.value),
                })
              }}</v-button>
            </v-col>
          </v-row>
        </v-col>
        <v-col class="col-4">
          <div class="w-full flex justify-end">
            <v-button
              v-if="$route.name === 'createTemplateSnippet'"
              :active="teamCan('template-snippets')"
              :withLockIcon="!teamCan('template-snippets')"
              primary
              @click.native="submitTemplateSnippet(false)"
              >{{ $t("actions.next") }}</v-button
            >
            <v-button
              :active="teamCan('template-snippets') && editingSubjectField === '' && editingField === ''"
              v-if="$route.name === 'editTemplateSnippet'"
              :withLockIcon="!teamCan('template-snippets')"
              primary
              @click.native="submitTemplateSnippet(true)"
              >{{ $t("actions.save") }}</v-button
            >
          </div>
        </v-col>
      </v-row>
    </form>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import templateVariablesPlugin from "@/assets/js/redactorPlugins/template_variables";
import multiGenderPlugin from "@/assets/js/redactorPlugins/multigender_text";
import teamAbilities from "@/mixins/teamAbilities.js";

export default {
  name: "FormTemplateSnippet",
  mixins: [teamAbilities],
  data() {
    return {
      submitActive: false,
      currentSnippetType: "",
      name: "",
      defaultValue: {},
      defaultSubject: {},
      editingField: "",
      editingSubjectField: "",
      locale: "",
      redactorCustomConfig: {
        plugins: ["template_variables", "multigender_text"],
        templateVariables: [],
      },
      selectedSubjectLanguageToAdd: {},
      selectedLanguageToAdd: {},
      localeSubjectRemainingOptions: [],
      localeRemainingOptions: [],
      loadingLangContent: "",
      loadingLangSubject: "",
      localeContent: {},
      localeSubject: {},
      type: {
        label: this.$t("templateSnippets.status.text"),
        value: "text",
      },
      typeOptions: [
        {
          label: this.$t("templateSnippets.status.text"),
          value: "text",
        },
        {
          label: this.$t("templateSnippets.status.email"),
          value: "email",
        },
      ],
      breadcrumbCreateTemplateItems: [
        {
          label: this.$t("menus.templates"),
          route: { name: "Settings", params: { tab: "templates" } },
        },
        {
          label: "",
          route: { name: "Template", params: { uid: "" } },
        },
        {
          label: this.$t("menus.createTemplateSnippet"),
          active: true,
        },
      ],
      breadcrumbEditTemplateItems: [
        {
          label: this.$t("menus.templates"),
          route: { name: "Settings", params: { tab: "templates" } },
        },
        {
          label: "-",
          route: { name: "Template", params: { uid: "" } },
        },
        {
          label: "",
          route: { name: "TemplateSnippet", params: { template: "", uid: "" } },
        },
        {
          label: this.$t("menus.editTemplateSnippet"),
          active: true,
        },
      ],
      breadcrumbMobileCreateItem: {
        label: this.$t("menus.templates"),
        route: { name: "Settings", params: { tab: "templates" } },
      },
      breadcrumbMobileEditItem: {
        label: "",
        route: { name: "Template", params: { uid: "" } },
      },
    };
  },
  created() {
    window.Redactor.add("plugin", "template_variables", templateVariablesPlugin);
    window.Redactor.add("plugin", "multigender_text", multiGenderPlugin);
    this.loadPageData();
  },
  methods: {
    ...mapActions(["getTemplate", "createTemplateSnippet", "editTemplateSnippet", "getTemplateSnippet"]),
    addLangContent() {
      this.localeContent[this.selectedLanguageToAdd.value] = {
        default: this.$t("templateSnippets.defaultContent"),
        f: "",
        m: "",
      };
      for (const i in this.localeRemainingOptions) {
        if (this.localeRemainingOptions[i].value === this.selectedLanguageToAdd.value) {
          this.localeRemainingOptions.splice(i, 1);
          break;
        }
      }
      if (this.localeRemainingOptions.length) {
        this.selectedLanguageToAdd = this.localeRemainingOptions[0];
      } else {
        this.selectedLanguageToAdd = {};
      }
    },
    addLangSubject() {
      this.localeSubject[this.selectedSubjectLanguageToAdd.value] = {
        default: this.$t("templateSnippets.defaultSubject"),
        f: "",
        m: "",
      };
      for (const i in this.localeSubjectRemainingOptions) {
        if (this.localeSubjectRemainingOptions[i].value === this.selectedSubjectLanguageToAdd.value) {
          this.localeSubjectRemainingOptions.splice(i, 1);
          break;
        }
      }
      if (this.localeSubjectRemainingOptions.length) {
        this.selectedSubjectLanguageToAdd = this.localeSubjectRemainingOptions[0];
      } else {
        this.selectedSubjectLanguageToAdd = {};
      }
    },
    removeLangContent(lang) {
      if (Object.prototype.hasOwnProperty.call(this.localeContent, lang)) {
        this.$delete(this.localeContent, lang);
        this.localeRemainingOptions.push({
          label: this.$t("lang." + lang),
          value: lang,
        });
        if (this.editingField) {
          const pieces = this.editingField.split("-");
          if (pieces[0] === lang) {
            this.editingField = "";
          }
        }
      }
    },
    removeLangSubject(lang) {
      if (Object.prototype.hasOwnProperty.call(this.localeSubject, lang)) {
        this.$delete(this.localeSubject, lang);
        this.localeSubjectRemainingOptions.push({
          label: this.$t("lang." + lang),
          value: lang,
        });
        if (this.editingSubjectField) {
          const pieces = this.editingSubjectField.split("-");
          if (pieces[0] === lang) {
            this.editingSubjectField = "";
          }
        }
      }
    },
    toggleEditor(currentEditField, field = "body") {
      if (field === "body") {
        if (this.editingField === currentEditField) {
          const pieces = currentEditField.split("-");
          let continueEditing = true;
          if (pieces[1] === "default") {
            continueEditing =
              pieces[0] === "default"
                ? this.checkDefaultValueNotNull(this.defaultValue)
                : this.checkDefaultValueNotNull(this.localeContent[pieces[0]]);
          }
          if (continueEditing) {
            this.editingField = "";
          }
        } else {
          this.editingField = currentEditField;
        }
      } else {
        if (this.editingSubjectField === currentEditField) {
          const pieces = currentEditField.split("-");
          let continueEditing = true;
          if (pieces[1] === "default") {
            continueEditing =
              pieces[0] === "default"
                ? this.checkDefaultValueNotNull(this.defaultSubject)
                : this.checkDefaultValueNotNull(this.localeSubject[pieces[0]]);
          }
          if (continueEditing) {
            this.editingSubjectField = "";
          }
        } else {
          this.editingSubjectField = currentEditField;
        }
      }
    },
    checkDefaultValueNotNull(valueArray) {
      if (!valueArray.default || valueArray.default === "") {
        this.$snotify.error(this.$t("toasts.editedTemplateSnippet.empty"), this.$t("toasts.error"), {
          timeout: 0,
          icon: this.$errorIcon,
        });
        return false;
      }
      return true;
    },
    loadPageData() {
      const vm = this;
      const p1 = vm.getTemplate({ template: this.$route.params.template });
      let p = null;
      if (vm.$route.name === "editTemplateSnippet") {
        const p2 = vm.getTemplateSnippet({
          template: this.$route.params.template,
          uid: this.$route.params.uid,
        });
        p = Promise.all([p1, p2]);
      } else {
        p = p1;
      }
      p.then(() => {
        if (vm.$route.name === "editTemplateSnippet") {
          vm.setTemplate();
        }
        vm.breadcrumbCreateTemplateItems[1].label = vm.currentTemplate.name;
        vm.breadcrumbCreateTemplateItems[1].route = {
          name: "Template",
          params: { uid: this.currentTemplate.uid },
        };
        vm.breadcrumbEditTemplateItems[1].label = vm.currentTemplate.name;
        vm.breadcrumbEditTemplateItems[1].route = {
          name: "Template",
          params: { uid: this.currentTemplate.uid },
        };
        vm.breadcrumbEditTemplateItems[2].label = vm.currentTemplateSnippet.name;
        vm.breadcrumbEditTemplateItems[2].route = {
          name: "TemplateSnippet",
          params: {
            template: this.currentTemplate.uid,
            uid: this.currentTemplateSnippet.uid,
          },
        };
        vm.$store.commit("GLOBAL_CUSTOM_LOADING_ENDED");
      }).catch(() => {
        vm.$store.commit("GLOBAL_CUSTOM_LOADING_ENDED");
      });
    },
    setLanguageOptions(languagesToIgnoreContent, languagesToIgnoreSubject) {
      const initialLanguages = [];
      const initialLanguagesSubject = [];
      for (const i in this.currentTemplate.languages) {
        if (languagesToIgnoreContent.indexOf(this.currentTemplate.languages[i]) === -1) {
          initialLanguages.push({
            label: this.$t("lang." + this.currentTemplate.languages[i]),
            value: this.currentTemplate.languages[i],
          });
        }
        if (languagesToIgnoreSubject.indexOf(this.currentTemplate.languages[i]) === -1) {
          initialLanguagesSubject.push({
            label: this.$t("lang." + this.currentTemplate.languages[i]),
            value: this.currentTemplate.languages[i],
          });
        }
      }
      this.localeRemainingOptions = initialLanguages;
      this.localeSubjectRemainingOptions = initialLanguagesSubject;
    },
    setVariablesForRedactor() {
      if (this.currentSnippetType === "text") {
        this.redactorCustomConfig.templateVariables = [
          {
            title: "owner_name",
            // eslint-disable-next-line no-template-curly-in-string
            args: "${owner:first_name}",
            api: "plugin.template_variables.insertVar",
          },
          {
            title: "owner_surname",
            // eslint-disable-next-line no-template-curly-in-string
            args: "${owner:last_name}",
            api: "plugin.template_variables.insertVar",
          },
          {
            title: "contact_name",
            // eslint-disable-next-line no-template-curly-in-string
            args: "${contact:first_name}",
            api: "plugin.template_variables.insertVar",
          },
          {
            title: "contact_surname",
            // eslint-disable-next-line no-template-curly-in-string
            args: "${contact:last_name}",
            api: "plugin.template_variables.insertVar",
          },
        ];
      } else if (this.currentSnippetType === "email") {
        this.redactorCustomConfig.templateVariables = [
          {
            title: "project_link",
            // eslint-disable-next-line no-template-curly-in-string
            args: "${project:link}",
            api: "plugin.template_variables.insertVar",
          },
          {
            title: "client_name",
            // eslint-disable-next-line no-template-curly-in-string
            args: "${client:first_name}",
            api: "plugin.template_variables.insertVar",
          },
          {
            title: "client_surname",
            // eslint-disable-next-line no-template-curly-in-string
            args: "${client:last_name}",
            api: "plugin.template_variables.insertVar",
          },
          {
            title: "contact_name",
            // eslint-disable-next-line no-template-curly-in-string
            args: "${contact:first_name}",
            api: "plugin.template_variables.insertVar",
          },
          {
            title: "contact_surname",
            // eslint-disable-next-line no-template-curly-in-string
            args: "${contact:last_name}",
            api: "plugin.template_variables.insertVar",
          },
        ];
        if (this.teams[this.$route.params.team].account.team.attributes.portal_enabled) {
          const list1 = this.redactorCustomConfig.templateVariables.splice(0, 1);
          const list2 = this.redactorCustomConfig.templateVariables;
          const portalLink = {
            title: "portal_link",
            // eslint-disable-next-line no-template-curly-in-string
            args: "${portal:link}",
            api: "plugin.template_variables.insertVar",
          };
          this.redactorCustomConfig.templateVariables = [...list1, portalLink, ...list2];
        }
      }
    },
    setGenderValIfEmpty(genderArray) {
      if (!Object.prototype.hasOwnProperty.call(genderArray, "f")) {
        genderArray.f = "";
      }
      if (!Object.prototype.hasOwnProperty.call(genderArray, "m")) {
        genderArray.m = "";
      }
      return genderArray;
    },
    setTemplate() {
      this.name = this.currentTemplateSnippet.name;
      if (this.$route.name === "editTemplateSnippet") {
        this.currentSnippetType = this.$h.templateSnippetsStatus(this.currentTemplateSnippet.status, "type", false);
      }
      const contentLanguagesIgnoreFromSelect = [];
      for (const lang in this.currentTemplateSnippet.content.body) {
        if (lang === "default") {
          this.defaultValue = this.setGenderValIfEmpty(
            JSON.parse(JSON.stringify(this.currentTemplateSnippet.content.body[lang]))
          );
        } else {
          contentLanguagesIgnoreFromSelect.push(lang);
          this.localeContent[lang] = this.setGenderValIfEmpty(
            JSON.parse(JSON.stringify(this.currentTemplateSnippet.content.body[lang]))
          );
        }
      }
      const subjectLanguagesIgnoreFromSelect = [];
      for (const langS in this.currentTemplateSnippet.content.subject) {
        if (langS === "default") {
          this.defaultSubject = this.setGenderValIfEmpty(
            JSON.parse(JSON.stringify(this.currentTemplateSnippet.content.subject[langS]))
          );
        } else {
          subjectLanguagesIgnoreFromSelect.push(langS);
          this.localeSubject[langS] = this.setGenderValIfEmpty(
            JSON.parse(JSON.stringify(this.currentTemplateSnippet.content.subject[langS]))
          );
        }
      }
      this.setVariablesForRedactor();
      this.setLanguageOptions(contentLanguagesIgnoreFromSelect, subjectLanguagesIgnoreFromSelect);

      if (this.localeRemainingOptions.length) {
        this.selectedLanguageToAdd = this.localeRemainingOptions[0];
      }
      if (this.localeSubjectRemainingOptions.length) {
        this.selectedSubjectLanguageToAdd = this.localeSubjectRemainingOptions[0];
      }
    },
    getGenderArrayWithoutEmpty(genderArray) {
      const returnArray = {
        default: genderArray.default,
      };
      if (genderArray.m) {
        returnArray.m = genderArray.m;
      }
      if (genderArray.f) {
        returnArray.f = genderArray.f;
      }
      return returnArray;
    },
    encodeStringsFromObject(o) {
      let obj = { default: this.$base64.encode(o.default) };
      if (o.m) {
        obj.m = this.$base64.encode(o.m);
      }
      if (o.f) {
        obj.f = this.$base64.encode(o.f);
      }
      return obj;
    },
    submitTemplateSnippet(isEdit) {
      if (!this.teamCan("template-snippets")) {
        this.$h.showSubscriptionErrorModal(
          this.$modal,
          this.teams[this.$route.params.team] && this.teams[this.$route.params.team].account.role.includes("owner")
        );
      } else if (this.editingSubjectField === "" && this.editingField === "") {
        const data = {
          name: this.name,
        };
        if (isEdit) {
          data.content = {
            body: {
              default: this.encodeStringsFromObject(this.getGenderArrayWithoutEmpty(this.defaultValue)),
            },
          };
          for (const lang in this.localeContent) {
            data.content.body[lang] = this.encodeStringsFromObject(
              this.getGenderArrayWithoutEmpty(this.localeContent[lang])
            );
          }
          if (this.currentSnippetType === "email") {
            data.content.subject = {
              default: this.encodeStringsFromObject(this.getGenderArrayWithoutEmpty(this.defaultSubject)),
            };
            for (const langS in this.localeSubject) {
              data.content.subject[langS] = this.encodeStringsFromObject(
                this.getGenderArrayWithoutEmpty(this.localeSubject[langS])
              );
            }
          }
        } else {
          data.type = this.type.value;
          data.content = {
            body: {
              default: {
                default: this.$base64.encode(this.$t("templateSnippets.defaultContent")),
              },
            },
          };
          if (data.type === "email") {
            data.content.subject = {
              default: {
                default: this.$base64.encode(this.$t("templateSnippets.defaultSubject")),
              },
            };
          }
        }
        this.$validator.validateAll().then((result) => {
          if (result) {
            if (isEdit) {
              this.editTemplateSnippet({
                params: {
                  template: this.currentTemplate.uid,
                  snippet: this.currentTemplateSnippet.uid,
                },
                data,
              })
                .then(() => {
                  this.$snotify.success(this.$t("toasts.editedTemplate.success"), this.$t("toasts.success"), {
                    icon: this.$successIcon,
                  });
                  this.$goTo("TemplateSnippet", {
                    template: this.currentTemplate.uid,
                    uid: this.currentTemplateSnippet.uid,
                  });
                })
                .catch((err) => {
                  if (err.response && !err.response.data.error.custom) {
                    this.$snotify.error(this.$t("toasts.editedTemplateSnippet.error"), this.$t("toasts.error"), {
                      timeout: 0,
                      icon: this.$errorIcon,
                    });
                  }
                });
            } else {
              this.createTemplateSnippet({
                params: { template: this.currentTemplate.uid },
                data,
              })
                .then((res) => {
                  this.$snotify.success(this.$t("toasts.editedTemplateSnippet.success"), this.$t("toasts.success"), {
                    icon: this.$successIcon,
                  });
                  this.$goTo("editTemplateSnippet", {
                    template: this.currentTemplate.uid,
                    uid: res.uid,
                  });
                })
                .catch((err) => {
                  if (err.response && !err.response.data.error.custom) {
                    this.$snotify.error(this.$t("toasts.createdTemplate.error"), this.$t("toasts.error"), {
                      timeout: 0,
                      icon: this.$errorIcon,
                    });
                  }
                });
            }
          } else {
            this.$snotify.error(this.$t("toasts.editedTemplateSnippet.validation"), this.$t("toasts.error"), {
              timeout: 0,
              icon: this.$errorIcon,
            });
          }
        });
      }
    },
  },
  computed: {
    filteredLocaleSubject() {
      if (this.$route.name !== "editTemplateSnippet" || !this.currentSnippetType === "email") {
        return {};
      }
      return this.localeSubject;
    },
    filteredLocaleContent() {
      if (this.$route.name !== "editTemplateSnippet") {
        return {};
      }
      return this.localeContent;
    },
    ...mapGetters({
      teams: "auth_get_teams",
      currentTemplate: "templates_get_current_template",
      currentTemplateSnippet: "templates_get_current_template_snippet",
    }),
  },
};
</script>
